<template>
    <div>
        <register :isMobile='true'/>
    </div>
</template>
<script>
import Register from '@/pages/auth/Register'
export default {
    name:'moblie_Login',
    components:{
        Register
    }    
}
</script>
<style lang="scss" scoped>
</style>